// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-card {
  background-color: #e8e9ea;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0% 5%;
  margin: 0;
  background-color: #00468c;
  color: #fff;
}

.invoice-close-btn {
  font-size: xx-large;
  font-weight: bold;
  cursor: pointer;
  background: none;
  border: none;
  color: white;
}

.invoice-section {
  padding: 1%;
}

.invoice-section h3 {
  font-size: 16px;
  color: #4b5563;
  font-weight: 600;
  text-align: center;
  margin: 0;
}

.in-radio-group {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 8px;
}

.radio-group label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #4b5563;
  cursor: pointer;
}

.radio-group input {
  margin-right: 6px;
}

.invoice-form {
  padding: 1% 0;
  margin: 0 2%;
  background-color: #dfdfdf;
}

.invoice-input-group {
  display: flex;
  justify-content: center;
  margin: 0 2%;
  gap: 6%;
}

.invoice-input-group div {
  flex: 1 1;
}

.invoice-form label {
  font-size: 14px;
  color: #4b5563;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

.invoice-form input {
  width: 90%;
  border: 1px solid #ccc;
  padding: 4%;
  border-radius: 4px;
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.checkbox-group input {
  cursor: pointer;
}

.amount-details {
  display: flex;
  gap: 12px;
  align-items: center;
}

.amount-details input {
  width: 100px;
  text-align: center;
  font-weight: bold;
}

.invoice-terms {
  text-align: center;
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
  margin: 2% 2% 5% 2%;
}

.invoice-buttons {
  display: flex;
  justify-content: center;
  gap: 10%;
  padding: 1%;
}

.invoice-buttons button {
  padding: 1% 2%;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.cancel-btn {
  border: 2px solid #79c42b;
  color: #000;
}

.submit-btn {
  background-color: #79c42b;
  color: white;
  border: none;
}

.invoice-form-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.invoice-form-content {
  background-color: #e8e9ea;
  margin: 0%;
  padding: 0;
  width: 70%;
  position: relative;
}

.back-btn {
  font-size: xx-large;
  color: #004dc6;
}

/* Invoice Table Styling */
.invoice-table {
  width: 100%;
  border-collapse: collapse;
  margin: 5% 0;
  font-size: 16px;
  text-align: left;
}

/* Header Styling */
.invoice-table thead tr {
  background-color: #f2f2f2;
  color: #000;
  font-weight: bold;
}

/* Cell Padding and Borders */
.invoice-table th,
.invoice-table td {
  padding: 0.5%;
  border: 1px solid #d9d9d9;
  align-items: center;
  text-align: center;
}

.invoice-table td {
  background-color: #fff;
}

.invoice-table td:nth-child(4),
.invoice-table td:nth-child(5),
.invoice-table td:nth-child(6) {
  text-align: right;
}

.invoice-table td select {
  width: 90px;
  padding: 2%;
  border-radius: 20px;
}

.invoice-action-buttons {
  min-width: 60px;
  display: flex;
  justify-content: space-around;
}

.in-update-icon,
.in-view-icon,
.in-edit-icon,
.in-download-icon {
  font-size: x-large;
  color: #949494;
  cursor: pointer;
}

.hidden-print {
  visibility: hidden;
  height: 0;
  overflow: hidden;
}

/* Container for the line items wrapper */
.line-items-wrapper {
  padding: 2%;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.line-items-section {
  max-height: 100px;
  overflow-y: auto;
  border: 1px solid #000;
  padding: 1% 0;
}

/* Each row for a line item */
.line-item-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4%;
  padding-bottom: 10px;
}

/* For each field in a row */
.line-item-row > div {
  display: flex;
  flex-direction: column;
}

/* Serial number field styling */
.serial-number-field {
  min-width: 40px;
  text-align: center;
}

.serial-number-field input {
  width: 60px;
  font-size: 0.9rem;
  text-align: center;
  padding: 12% 0;
  background: none;
  border: none;
}

/* Container for the inline add button */
.add-button-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 2%;
}

/* Style for the inline + button */
.add-line-item-btn {
  background-color: #79c42b;
  color: #fff;
  border: none;
  padding: 4px 8px;
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.add-line-item-btn:hover {
  background-color: #79c42b;
}

.invoice-summary {
  display: flex;
  gap: 1rem;
  padding: 0;
  margin: 0;
}

/* Terms & Conditions block */
.terms-conditions {
  flex: 1 1;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0 1rem;
}

.terms-conditions h4 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.terms-conditions textarea {
  width: 100%;
  height: 160px;
  resize: vertical;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: medium;
}

/* Totals block */
.totals {
  flex: 1 1;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0 1rem;
}

.totals h4 {
  margin-top: 0%;
  margin-bottom: 0.5rem;
}

/* Align the label/input pairs in totals */
.totals .in-input-group {
  display: flex;
  flex-wrap: wrap;
}

.totals .in-input-group > div {
  display: flex;
  min-width: 100%;
}

.totals label {
  text-align: center;
  width: 50%;
  margin: 2% 0;
  font-weight: 600;
}

.totals input {
  padding: 1% 2%;
  border-radius: 4px;
  border: 1px solid #ccc;
  margin: 1% 0;
}

.in-gst-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 1%;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 25px;
  width: 93%;
}

.in-percent {
  margin: 1% 2%;
  padding: 0 2%;
}

.in-input input {
  width: 60px;
}

.description-cell {
  max-width: 200px;
  max-height: 1.1em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: max-height 0.3s ease, white-space 0.3s ease;
  cursor: pointer;
}

.description-cell:hover {
  max-height: 200px;
  white-space: normal;
}

.char-counter {
  font-size: 12px;
  color: gray;
  text-align: right;
  margin: 0;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.popup-modal {
  background: #fff;
  border-radius: 10px;
  width: 90%;
  max-width: 400px;
  padding: 1.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.popup-title {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
}

.popup-checkbox {
  margin-bottom: 1.5rem;
  font-size: 1rem;
  text-align: center;
}

.popup-checkbox label {
  margin: 0 2%;
}

.popup-actions {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
}

.btn {
  padding: 0.5rem 1rem;
  font-size: 0.95rem;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}

.btn.cancel {
  background: none;
  color: #000;
  border: 2px solid #79c42b;
}

.btn.confirm {
  background: #79c42b;
  color: #fff;
}

/* Modal overlay styles */
.tds-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Modal content styles */
.tds-modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* Header styling */
.tds-modal-content h3 {
  margin-top: 0;
  font-size: 1.4rem;
  color: #333;
  text-align: center;
}

/* Paragraph and label styling */
.tds-modal-content p,
.tds-modal-content label {
  color: #555;
  margin-bottom: 10px;
  text-align: center;
}

/* Form inputs styling */
.tds-modal-content input[type="checkbox"] {
  margin-right: 5px;
}

.tds-modal-content input[type="number"],
.tds-modal-content input[type="text"] {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  margin-bottom: 15px;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

/* Button styling */
.tds-save {
  padding: 10px 15px;
  margin: 5px 5px 5px 80px;
  border: none;
  border-radius: 4px;
  background-color: #79c42b;
  color: #fff;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.tds-save:hover {
  background-color: #76c523;
}

/* Optional: Cancel button with different style */
.tds-cancel {
  padding: 10px 15px;
  margin: 5px 5px 5px 80px;
  border: none;
  border-radius: 4px;
  border: 2px solid #79c42b;
  color: #000;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.tds-cancel:hover {
  background-color: #a7c38a;
}

.tds-checkbox {
  text-align: center;
  margin: 5%;
}
`, "",{"version":3,"sources":["webpack://./src/components/UpdateProjects/Invoice.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;;;EAIE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,OAAO;EACP,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;EACvD,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,sCAAsC;EAC5E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;;EAEE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":[".invoice-card {\n  background-color: #e8e9ea;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  width: 100%;\n}\n\n.invoice-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0% 5%;\n  margin: 0;\n  background-color: #00468c;\n  color: #fff;\n}\n\n.invoice-close-btn {\n  font-size: xx-large;\n  font-weight: bold;\n  cursor: pointer;\n  background: none;\n  border: none;\n  color: white;\n}\n\n.invoice-section {\n  padding: 1%;\n}\n\n.invoice-section h3 {\n  font-size: 16px;\n  color: #4b5563;\n  font-weight: 600;\n  text-align: center;\n  margin: 0;\n}\n\n.in-radio-group {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.radio-group label {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #4b5563;\n  cursor: pointer;\n}\n\n.radio-group input {\n  margin-right: 6px;\n}\n\n.invoice-form {\n  padding: 1% 0;\n  margin: 0 2%;\n  background-color: #dfdfdf;\n}\n\n.invoice-input-group {\n  display: flex;\n  justify-content: center;\n  margin: 0 2%;\n  gap: 6%;\n}\n\n.invoice-input-group div {\n  flex: 1;\n}\n\n.invoice-form label {\n  font-size: 14px;\n  color: #4b5563;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.invoice-form input {\n  width: 90%;\n  border: 1px solid #ccc;\n  padding: 4%;\n  border-radius: 4px;\n}\n\n.checkbox-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.checkbox-group input {\n  cursor: pointer;\n}\n\n.amount-details {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.amount-details input {\n  width: 100px;\n  text-align: center;\n  font-weight: bold;\n}\n\n.invoice-terms {\n  text-align: center;\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 600;\n  margin: 2% 2% 5% 2%;\n}\n\n.invoice-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 10%;\n  padding: 1%;\n}\n\n.invoice-buttons button {\n  padding: 1% 2%;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.cancel-btn {\n  border: 2px solid #79c42b;\n  color: #000;\n}\n\n.submit-btn {\n  background-color: #79c42b;\n  color: white;\n  border: none;\n}\n\n.invoice-form-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.invoice-form-content {\n  background-color: #e8e9ea;\n  margin: 0%;\n  padding: 0;\n  width: 70%;\n  position: relative;\n}\n\n.back-btn {\n  font-size: xx-large;\n  color: #004dc6;\n}\n\n/* Invoice Table Styling */\n.invoice-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 5% 0;\n  font-size: 16px;\n  text-align: left;\n}\n\n/* Header Styling */\n.invoice-table thead tr {\n  background-color: #f2f2f2;\n  color: #000;\n  font-weight: bold;\n}\n\n/* Cell Padding and Borders */\n.invoice-table th,\n.invoice-table td {\n  padding: 0.5%;\n  border: 1px solid #d9d9d9;\n  align-items: center;\n  text-align: center;\n}\n\n.invoice-table td {\n  background-color: #fff;\n}\n\n.invoice-table td:nth-child(4),\n.invoice-table td:nth-child(5),\n.invoice-table td:nth-child(6) {\n  text-align: right;\n}\n\n.invoice-table td select {\n  width: 90px;\n  padding: 2%;\n  border-radius: 20px;\n}\n\n.invoice-action-buttons {\n  min-width: 60px;\n  display: flex;\n  justify-content: space-around;\n}\n\n.in-update-icon,\n.in-view-icon,\n.in-edit-icon,\n.in-download-icon {\n  font-size: x-large;\n  color: #949494;\n  cursor: pointer;\n}\n\n.hidden-print {\n  visibility: hidden;\n  height: 0;\n  overflow: hidden;\n}\n\n/* Container for the line items wrapper */\n.line-items-wrapper {\n  padding: 2%;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.line-items-section {\n  max-height: 100px;\n  overflow-y: auto;\n  border: 1px solid #000;\n  padding: 1% 0;\n}\n\n/* Each row for a line item */\n.line-item-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4%;\n  padding-bottom: 10px;\n}\n\n/* For each field in a row */\n.line-item-row > div {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Serial number field styling */\n.serial-number-field {\n  min-width: 40px;\n  text-align: center;\n}\n\n.serial-number-field input {\n  width: 60px;\n  font-size: 0.9rem;\n  text-align: center;\n  padding: 12% 0;\n  background: none;\n  border: none;\n}\n\n/* Container for the inline add button */\n.add-button-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 2%;\n}\n\n/* Style for the inline + button */\n.add-line-item-btn {\n  background-color: #79c42b;\n  color: #fff;\n  border: none;\n  padding: 4px 8px;\n  border-radius: 50%;\n  font-size: 1.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.add-line-item-btn:hover {\n  background-color: #79c42b;\n}\n\n.invoice-summary {\n  display: flex;\n  gap: 1rem;\n  padding: 0;\n  margin: 0;\n}\n\n/* Terms & Conditions block */\n.terms-conditions {\n  flex: 1;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 0 1rem;\n}\n\n.terms-conditions h4 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\n.terms-conditions textarea {\n  width: 100%;\n  height: 160px;\n  resize: vertical;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: medium;\n}\n\n/* Totals block */\n.totals {\n  flex: 1;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 0 1rem;\n}\n\n.totals h4 {\n  margin-top: 0%;\n  margin-bottom: 0.5rem;\n}\n\n/* Align the label/input pairs in totals */\n.totals .in-input-group {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.totals .in-input-group > div {\n  display: flex;\n  min-width: 100%;\n}\n\n.totals label {\n  text-align: center;\n  width: 50%;\n  margin: 2% 0;\n  font-weight: 600;\n}\n\n.totals input {\n  padding: 1% 2%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  margin: 1% 0;\n}\n\n.in-gst-group {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fff;\n  padding: 1%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  height: 25px;\n  width: 93%;\n}\n\n.in-percent {\n  margin: 1% 2%;\n  padding: 0 2%;\n}\n\n.in-input input {\n  width: 60px;\n}\n\n.description-cell {\n  max-width: 200px;\n  max-height: 1.1em;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  transition: max-height 0.3s ease, white-space 0.3s ease;\n  cursor: pointer;\n}\n\n.description-cell:hover {\n  max-height: 200px;\n  white-space: normal;\n}\n\n.char-counter {\n  font-size: 12px;\n  color: gray;\n  text-align: right;\n  margin: 0;\n}\n\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.popup-modal {\n  background: #fff;\n  border-radius: 10px;\n  width: 90%;\n  max-width: 400px;\n  padding: 1.5rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.popup-title {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.popup-checkbox {\n  margin-bottom: 1.5rem;\n  font-size: 1rem;\n  text-align: center;\n}\n\n.popup-checkbox label {\n  margin: 0 2%;\n}\n\n.popup-actions {\n  display: flex;\n  justify-content: center;\n  gap: 0.75rem;\n}\n\n.btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.95rem;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n}\n\n.btn.cancel {\n  background: none;\n  color: #000;\n  border: 2px solid #79c42b;\n}\n\n.btn.confirm {\n  background: #79c42b;\n  color: #fff;\n}\n\n/* Modal overlay styles */\n.tds-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Modal content styles */\n.tds-modal-content {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n/* Header styling */\n.tds-modal-content h3 {\n  margin-top: 0;\n  font-size: 1.4rem;\n  color: #333;\n  text-align: center;\n}\n\n/* Paragraph and label styling */\n.tds-modal-content p,\n.tds-modal-content label {\n  color: #555;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n/* Form inputs styling */\n.tds-modal-content input[type=\"checkbox\"] {\n  margin-right: 5px;\n}\n\n.tds-modal-content input[type=\"number\"],\n.tds-modal-content input[type=\"text\"] {\n  width: 100%;\n  padding: 8px;\n  margin-top: 5px;\n  margin-bottom: 15px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n}\n\n/* Button styling */\n.tds-save {\n  padding: 10px 15px;\n  margin: 5px 5px 5px 80px;\n  border: none;\n  border-radius: 4px;\n  background-color: #79c42b;\n  color: #fff;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.3s ease;\n}\n\n.tds-save:hover {\n  background-color: #76c523;\n}\n\n/* Optional: Cancel button with different style */\n.tds-cancel {\n  padding: 10px 15px;\n  margin: 5px 5px 5px 80px;\n  border: none;\n  border-radius: 4px;\n  border: 2px solid #79c42b;\n  color: #000;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.3s ease;\n}\n\n.tds-cancel:hover {\n  background-color: #a7c38a;\n}\n\n.tds-checkbox {\n  text-align: center;\n  margin: 5%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
